import React from 'react'
import { StyleMicrosoft } from './style'

const ButtonMicrosoftLogin = ({ onClick, image, text }) => {

  return (
    <StyleMicrosoft>
      <div className='microsoft-button' onClick={onClick}>
        <div className='microsoft-icon-wrapper'>
          <img
            className='microsoft-icon'
            src={image}
            alt='microsoft-logo'
          />
        </div>
        <p className='button-text'><b>{text}</b></p>
      </div>
    </StyleMicrosoft>
  )
}

export default ButtonMicrosoftLogin
